import React from 'react'

const AdvertiseProperty = ({textBlack,textPink}) => {
  return (
    <div style={{ display: 'flex', width: '100%', justifyContent: 'center', alignItems: 'center',backgroundColor:"#FEE3F1" }}>
      <div class="advertise_immobile_container paddingDesktop" style={{maxWidth:"1340px"}}> 
          <div className='display_yolo_coliving' style={{gap:"5%"}}>
            <div>
            <div style={{padding:"10px 0"}}>
                <span className='fz-advertise_immobile_container'>
                    <span style={{color:"#101828"}}>
                      {textBlack}
                    </span> <span style={{color:"#FF0397"}} >{textPink}</span> </span>
            </div>
            </div>
            <div style={{display:"flex",alignItems:"center"}}>
              <a href='https://formulario.yolocoliving.com.br/crm_form_kjfxt/' target="" className="btn_owner_global_big">
                Cadastrar meu imóvel
              </a> 
          </div>
          </div> 
      </div> 
    </div>
  )
}

export default AdvertiseProperty